import { type NotificationType } from '@/redux/slices/notificationSlice'
import type { FormEntryPostFailureActivity } from '@/typings/domain'
import ItemWrapper from './ItemWrapper'

export default function FormEntryPostFailure({ notification }: { notification: NotificationType }) {
  const activity = notification.activity as FormEntryPostFailureActivity
  const formInfo = activity.formInfo

  if (!formInfo) return null

  return <ItemWrapper notification={notification}>《{formInfo.formName}》数据推送失败，请检查配置</ItemWrapper>
}
